const FILTER_ENUM = require('./filter-type-enum');
module.exports = function (atm, FiltersService) {
    return {
        restrict: 'E',
        scope: {
            filter: '=filterData'
        },
        link(scope) {
            scope.filtersService = FiltersService;
            scope.filterType = {
                radio: FILTER_ENUM.FILTER_RADIO
            };

            scope.applyFilter = function ({ Term, Min, Max, Name }) {

                let filterData;

                if (Term === null) {
                    filterData = { Min: Min.toString(), Max: Max.toString() };
                } else {
                    filterData = { Term: Name };
                }

                scope.filtersService.applyFilter(scope.filter.Name, filterData, scope.filter.Type);
            };
        },
        template: require('./filter-list-template.html')
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-list-directive.js
 **/